/*!
 * All material copyright ESRI, All Rights Reserved, unless otherwise specified.
 * See https://github.com/Esri/calcite-design-system/blob/dev/LICENSE.md for details.
 * v2.10.1
 */
import { C as Checkbox, d as defineCustomElement$1 } from './checkbox.js';

const CalciteCheckbox = Checkbox;
const defineCustomElement = defineCustomElement$1;

export { CalciteCheckbox, defineCustomElement };

//# sourceMappingURL=calcite-checkbox.js.map